import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CondominiumService } from '../../services/condominium.service';
import { GenericConfirmationDialogComponent } from '../../shared/delete-confirmation-dialog/generic-confirmation-dialog.component';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertDialogComponent } from '../../shared/alert-dialog/alert-dialog.component';

@Component({
    selector: 'app-change-owner',
    templateUrl: './change-owner.component.html',
    styleUrls: ['./change-owner.component.sass'],
    standalone: false
})
export class ChangeOwnerComponent implements OnInit {
  form!: FormGroup;
  condominiumId!: number;
  saving = false;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private condominiumService: CondominiumService
  ) {}

  ngOnInit(): void {
    this.condominiumId = +this.route.parent?.snapshot.params['id'];
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  onSave(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const dialogRef = this.dialog.open(GenericConfirmationDialogComponent, {
      data: {
        title: 'Troca de síndico',
        message: 'Atenção: está ação não poderá ser desfeita por você.',
        confirmButtonText: 'Ok'
      }
    });

    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.executeChangeOwner();
      }
    });
  }

  private executeChangeOwner(): void {
    this.saving = true;
    const email = this.form.value.email as string;
    this.condominiumService.changeOwner(this.condominiumId, email).subscribe({
      next: () => {
        this.saving = false;
        this.snackBar.open('Síndico alterado com sucesso', 'Fechar', { duration: 3000 });
        this.router.navigate(['/condominiums']);
      },
      error: (error: HttpErrorResponse) => {
        this.saving = false;
        const serverMessage = (error?.error && (error.error.detail)) || 'Erro ao alterar síndico.';
        this.dialog.open(AlertDialogComponent, {
          data: {
            title: 'Erro',
            message: serverMessage,
            okText: 'Ok'
          }
        });
      }
    });
  }
}


